import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../utils/app.utils";
import { icons } from "../../../assets/icons/icons";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import {
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { EquipmentApi } from "../../../api/equipment/equipment.api";
import { routeName } from "../../../routes/routeName";
import { useMediaQuery, useTheme } from "@mui/material";

type Props = {};

const BookingDeviceManagementContainer: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const [data, setData] = useState<any[]>([]);

  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getData = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      keyword: search ?? "",
    };

    const res = await EquipmentApi.getAllEquipment(query);
    const data = res.data;
    if (data.status < 300) {
      const formattedData =
        res.data?.data?.items?.map((item: any) => ({
          id_device: item.id_equipment || "",
          device_no: item.equipment_no || "",
          device_name: item.equipment_name || "",
          created_date: item.created_date || "",
        })) ?? [];
      setData(formattedData);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  const handleDelete = async (id_device: number) => {
    if (id_device) {
      alertActive(
        "ลบอุปกรณ์",
        "ท่านต้องการลบอุปกรณ์ ใช่หรือไม่",
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await EquipmentApi.deleteEquipment(+id_device)
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  "ลบอุปกรณ์ เรียบร้อย",
                  undefined,
                  undefined,
                  () => {
                    getData();
                  }
                );
              }
            })
            .catch(() => {
              alertError("ลบอุปกรณ์ ไม่สำเร็จ");
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const headCells = [
    {
      id: "no",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "ลำดับ",
    },
    {
      id: "period",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "รหัสอุปกรณ์",
    },
    {
      id: "period",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่ออุปกรณ์",
    },
    {
      id: "action",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      class: matches && data?.length > 0,
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const { id_device, device_no, device_name } = objData;

    const objRenderData = {
      key: id_device,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: device_no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: device_name ?? "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          component: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate(
                    routeName.cms.BookingRoomDeviceManagementForm +
                    `?id_device=${id_device}&mode=VIEW`
                  );
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
              <img
                onClick={() => {
                  navigate(
                    routeName.cms.BookingRoomDeviceManagementForm +
                    `?id_device=${id_device}&mode=UPDATE`
                  );
                }}
                src={icons.edit}
                alt="edit"
                style={{ cursor: "pointer", margin: "0px 12px" }}
              />
              <img
                src={icons.bag_cross}
                alt="bag_cross"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleDelete(id_device);
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    getData();
  }, [page, pageLimit, search, sortBy, sortType]);

  return (
    <div>
      <ContentHeading
        title={"จัดการอุปกรณ์"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหา ชื่ออุปกรณ์"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-9 md:col-span-9 sm:col-span-9 flex justify-end">
          <ButtonPrimary
            onClick={() => {
              navigate(
                routeName.cms.BookingRoomDeviceManagementForm + `?mode=CREATE`
              );
            }}
            mode="add"
            buttonName={"เพิ่มอุปกรณ์"}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default BookingDeviceManagementContainer;
